export const accordionStyles = {
  padding: 0,
  boxShadow: 'none',
  backgroundColor: 'transparent',

  '&:before': {
    display: 'none',
  },

  '& .MuiAccordionSummary-root': {
    padding: 0,
  },

  '& .MuiAccordionDetails-root': {
    padding: '12px 0 0',
  },
};

export const wrappingCellStyles = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};
